import TestimonyList from "../components/TestimonyList";

const ListTestimonyPage = () => {
  return (
    <TestimonyList />
  );
};

export default ListTestimonyPage;
